export default "__VITE_ASSET__DMwcvK0R__"